import * as yup from "yup";

export const episodeFormSchema = yup.object().shape({
  title: yup.string().required("episodeForm.titleError"),
  subtitle: yup.string().required("episodeForm.subtitleError"),
  description: yup
    .string()
    .min(4, "episodeForm.descriptionError")
    // .test(
    //   "is-valid-html",
    //   "Found invalid HTML. If issue persists, look for unclosed tags, try simplifying or use plain text.",
    //   function (value) {
    //     try {
    //       const parser = new DOMParser();
    //       let d = parser.parseFromString(
    //         `<?xml version="1.0"?><document>${value}</document>`,
    //         "text/xml"
    //       );
    //       let allnodes;

    //       if (d.querySelector("parsererror")) {
    //         return false;
    //       } else {
    //         d = parser.parseFromString(value, "text/html");
    //         allnodes = d.getElementsByTagName("*");
    //         for (var i = allnodes.length - 1; i >= 0; i--) {
    //           if (allnodes[i] instanceof HTMLUnknownElement) {
    //             return false;
    //           }
    //         }
    //       }
    //       return true;
    //     } catch (e) {
    //       return true;
    //     }
    //   }
    // )
    .required("episodeForm.descriptionError"),
  release_date: yup.string().required("episodeForm.releaseDateError"),
  release_time: yup.string().required("episodeForm.timeError"),
  file_url: yup
    .string()
    .url("Provide valid URL, starting with http:// or https://")
    .test("valid-file-type", "episodeForm.fileUrlError", function (value) {
      const valueArray = value.split("?")?.[0]?.split(".");
      const extension = valueArray[valueArray.length - 1];

      const extensionIsAllowed = ["mp3", "m4a"].includes(extension);

      if (!extensionIsAllowed) {
        return false;
      }
      return true;
    })
    .required(),
  hours: yup
    .string()
    .test("is-hour-int", "episodeForm.hoursError", function (value) {
      return Number.isInteger(+value);
    }),
  minutes: yup
    .string()
    .test("is-min-int", "episodeForm.minutesError", function (value) {
      return Number.isInteger(+value);
    })
    .test(
      "valid-minutes",
      "episodeForm.minutesError2",
      function (value, { parent }) {
        const hourValue = parent.hours;
        return !!!(value > 59 && hourValue > 0);
      }
    ),
  seconds: yup
    .number()
    .typeError("episodeForm.secondsError")
    .min(0, "episodeForm.secondsError")
    .test(
      "valid-seconds",
      "episodeForm.secondsError2",
      function (value, { parent }) {
        const minutesValue = parent.minutes;
        return !!!(value > 59 && minutesValue > 0);
      }
    )
    .required("Seconds is required"),
  video_length: yup
    .number()
    .typeError("episodeForm.fileSizeError")
    .required("episodeForm.fileSizeError"),
  age_restriction: yup
    .string()
    .oneOf(["true", "false"], "episodeForm.ageRestrictionError")
    .required("episodeForm.ageRestrictionError"),
});

export const generalFormSchema = yup.object().shape({
  title: yup.string().min(2, "generalForm.titleError"),
  image_url: yup
    .string()
    .url("generalForm.imageUrlError")
    .required("generalForm.imageUrlError"),
  subtitle: yup.string().required("generalForm.subtitleError"),
  summary: yup.string().min(10, "generalForm.summaryError"),
  author: yup.string().min(2, "generalForm.authorError"),
  owner: yup.string().min(2, "generalForm.ownerError"),
  url: yup
    .string()
    .url("generalForm.websiteUrlError")
    .required("generalForm.websiteUrlError"),
  lang: yup
    .string()
    .test("valid-lang", "generalForm.languageError", function (value) {
      return !![
        "af",
        "af-ZA",
        "ar",
        "ar-AE",
        "ar-BH",
        "ar-DZ",
        "ar-EG",
        "ar-IQ",
        "ar-JO",
        "ar-KW",
        "ar-LB",
        "ar-LY",
        "ar-MA",
        "ar-OM",
        "ar-QA",
        "ar-SA",
        "ar-SY",
        "ar-TN",
        "ar-YE",
        "az",
        "az-AZ",
        "az-AZ",
        "be",
        "be-BY",
        "bg",
        "bg-BG",
        "bs-BA",
        "ca",
        "ca-ES",
        "cs",
        "cs-CZ",
        "cy",
        "cy-GB",
        "da",
        "da-DK",
        "de",
        "de-AT",
        "de-CH",
        "de-DE",
        "de-LI",
        "de-LU",
        "dv",
        "dv-MV",
        "el",
        "el-GR",
        "en",
        "en-AU",
        "en-BZ",
        "en-CA",
        "en-CB",
        "en-GB",
        "en-IE",
        "en-JM",
        "en-NZ",
        "en-PH",
        "en-TT",
        "en-US",
        "en-ZA",
        "en-ZW",
        "eo",
        "es",
        "es-AR",
        "es-BO",
        "es-CL",
        "es-CO",
        "es-CR",
        "es-DO",
        "es-EC",
        "es-ES",
        "es-ES",
        "es-GT",
        "es-HN",
        "es-MX",
        "es-NI",
        "es-PA",
        "es-PE",
        "es-PR",
        "es-PY",
        "es-SV",
        "es-UY",
        "es-VE",
        "et",
        "et-EE",
        "eu",
        "eu-ES",
        "fa",
        "fa-IR",
        "fi",
        "fi-FI",
        "fo",
        "fo-FO",
        "fr",
        "fr-BE",
        "fr-CA",
        "fr-CH",
        "fr-FR",
        "fr-LU",
        "fr-MC",
        "gl",
        "gl-ES",
        "gu",
        "gu-IN",
        "he",
        "he-IL",
        "hi",
        "hi-IN",
        "hr",
        "hr-BA",
        "hr-HR",
        "hu",
        "hu-HU",
        "hy",
        "hy-AM",
        "id",
        "id-ID",
        "is",
        "is-IS",
        "it",
        "it-CH",
        "it-IT",
        "ja",
        "ja-JP",
        "ka",
        "ka-GE",
        "kk",
        "kk-KZ",
        "kn",
        "kn-IN",
        "ko",
        "ko-KR",
        "kok",
        "kok-IN",
        "ky",
        "ky-KG",
        "lt",
        "lt-LT",
        "lv",
        "lv-LV",
        "mi",
        "mi-NZ",
        "mk",
        "mk-MK",
        "mn",
        "mn-MN",
        "mr",
        "mr-IN",
        "ms",
        "ms-BN",
        "ms-MY",
        "mt",
        "mt-MT",
        "nb",
        "nb-NO",
        "nl",
        "nl-BE",
        "nl-NL",
        "nn-NO",
        "ns",
        "ns-ZA",
        "pa",
        "pa-IN",
        "pl",
        "pl-PL",
        "ps",
        "ps-AR",
        "pt",
        "pt-BR",
        "pt-PT",
        "qu",
        "qu-BO",
        "qu-EC",
        "qu-PE",
        "ro",
        "ro-RO",
        "ru",
        "ru-RU",
        "sa",
        "sa-IN",
        "se",
        "se-FI",
        "se-FI",
        "se-FI",
        "se-NO",
        "se-NO",
        "se-NO",
        "se-SE",
        "se-SE",
        "se-SE",
        "sk",
        "sk-SK",
        "sl",
        "sl-SI",
        "sq",
        "sq-AL",
        "sr-BA",
        "sr-BA",
        "sr-SP",
        "sr-SP",
        "sv",
        "sv-FI",
        "sv-SE",
        "sw",
        "sw-KE",
        "syr",
        "syr-SY",
        "ta",
        "ta-IN",
        "te",
        "te-IN",
        "th",
        "th-TH",
        "tl",
        "tl-PH",
        "tn",
        "tn-ZA",
        "tr",
        "tr-TR",
        "tt",
        "tt-RU",
        "ts",
        "uk",
        "uk-UA",
        "ur",
        "ur-PK",
        "uz",
        "uz-UZ",
        "uz-UZ",
        "vi",
        "vi-VN",
        "xh",
        "xh-ZA",
        "zh",
        "zh-CN",
        "zh-HK",
        "zh-MO",
        "zh-SG",
        "zh-TW",
        "zu",
        "zu-ZA",
      ].find((val) => val.toLowerCase() === value.toLowerCase());
    })
    .min(2, "generalForm.languageError"),
  copyright: yup.string().required("generalForm.copyrightError"),
  cemail: yup
    .string()
    .email("generalForm.contactEmailError")
    .required("generalForm.contactEmailError"),
  age_restriction: yup
    .string()
    .typeError("generalForm.ageRestrictionError")
    .oneOf(["true", "false"], "generalForm.ageRestrictionError")
    .required("generalForm.ageRestrictionError"),
  keywords: yup.string().required("generalForm.keywordsError"),

  episodes: yup
    .array()
    .of(episodeFormSchema)
    .min(1, "episodeList.episodeError")
    .required("episodeList.episodeError"),
});
